import { useCallback, useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import injectSheet, { useTheme } from 'react-jss'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'
import actions from '@/actions'
import constants from '@/constants'
import style from './style'

const libraries = ['places'] // To keep out of component because of performance

const StoreLocatorMap = ({ stores, classes }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: constants.config.GOOGLE_MAP_API_KEY,
    libraries, // Mandatory library "places" to work with geocoding
  })
  const [mapInstance, setMapInstance] = useState(null)
  const theme = useTheme()
  const initialZoom = useRef(6)
  const initialStyle = useRef({
    width: '100%',
    height: '100%',
  })
  const initialCenter = useRef({
    lat: 43.138,
    lng: 12.313,
  })

  /*------------------------------
  onLoad Map
  ------------------------------*/
  const onLoad = useCallback((map) => {
    setMapInstance(map)
  }, [])

  /*------------------------------
  OnMount Map
  ------------------------------*/
  const onUnmount = useCallback(() => {
    setMapInstance(null)
  }, [])

  /*------------------------------
  Redux Connect
  ------------------------------*/
  const { center } = useSelector((state) => ({
    center: state.stores.currentGeolocation,
  }), shallowEqual)

  /*------------------------------
  Move map on geocoding
  ------------------------------*/
  useEffect(() => {
    if (center.length > 0 && mapInstance) {
      mapInstance.panTo({ lat: center[0], lng: center[1] })
      mapInstance.setZoom(10)
    }
  }, [center, mapInstance])

  /*------------------------------
  Redux Actions
  ------------------------------*/
  const dispatch = useDispatch()
  const setModalOpen = useCallback((bool) => dispatch(actions.modal.setOpen(bool)), [dispatch])
  const setModalStoreID = useCallback((num) => dispatch(actions.modal.setModalStoreID(num)), [dispatch])

  /*------------------------------
  Handle Click Detail
  ------------------------------*/
  const handleClickDetail = (item) => {
    setModalStoreID(item.id)
    setModalOpen(true)
  }

  return (isLoaded && stores.length > 0) && (
    <>
      <GoogleMap
        mapContainerStyle={initialStyle.current}
        center={initialCenter.current}
        zoom={initialZoom.current}
        options={{
          disableDefaultUI: true,
          scrollwheel: true,
        }}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {stores.map((store, i) => (
          <Marker
            key={i.toString()}
            icon={{
              path: 'M7.72 0h25C39.59 0 42.4 5.62 39 12.5l-12.5 25c-3.5 6.88-9.1 6.88-12.5 0l-12.5-25C-2 5.62.84 0 7.72 0z',
              // fillColor: theme.markerColor[store.category[0].slug],
              fillColor: theme.markerColor['bs-point'],
              fillOpacity: 1,
              scale: 0.8,
              strokeColor: 'rgba(0, 0, 0, 0.2)',
              strokeWeight: 3,
            }}
            position={{ lat: Number(store.lat), lng: Number(store.lng) }}
            onClick={() => handleClickDetail(store)}
          />
        ))}
      </GoogleMap>
      <div className={classes.zoomControl}>
        <button // eslint-disable-line
          className={classes.zoomControlPlus}
          onClick={() => {
            const currentZoom = mapInstance.getZoom()
            mapInstance.setZoom(currentZoom + 1)
          }}
        />
        <button // eslint-disable-line
          className={classes.zoomControlMinus}
          onClick={() => {
            const currentZoom = mapInstance.getZoom()
            mapInstance.setZoom(currentZoom - 1)
          }}
        />
      </div>
    </>
  )
}

export default injectSheet(style)(StoreLocatorMap)
